import { Injectable } from '@angular/core';
import { ApiConstants } from '../../shared/constants/api-constants';
import { Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CurriculumDetails } from '../models/curriculumDetails';
import { TrainingItemUpdateDto } from '../models/trainingItemUpdateDto';
import { TrainingItemDto } from '../models/trainingItemDto';
import { EQMSScopeHierarchy } from '../../shared/models/scopes/eqms-scope-hierarchy';
import { NameCode } from '../../shared/models/name-code';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {
  treeData:EQMSScopeHierarchy = {} as EQMSScopeHierarchy;
  constructor(private httpClient: HttpClient) { }

    getLatestDocumentDetail(documentNumberList: string[]): Observable<any> {
      return this.httpClient.post(ApiConstants.Get_List_Of_DocumentLatestVersion_Api,documentNumberList);
    }

    addCurriculum(curriculumDetails: CurriculumDetails):Observable<any>{
      return this.httpClient.post(ApiConstants.Curriculum_Api, curriculumDetails);
    }  

    updateCurriculum(curriculumDetails: CurriculumDetails):Observable<any>{
      return this.httpClient.put(ApiConstants.Curriculum_Api, curriculumDetails);
    }  

    getCurriculum(parentEqmsScope?:number):Observable<any>{
      return this.httpClient.get(ApiConstants.Curriculum_Api + "/"+ `${parentEqmsScope}`)
    }

    getTrainingItems(trainingItemDto : TrainingItemDto):Observable<any>{
      return this.httpClient.post(ApiConstants.GetTrainingItems_Api, trainingItemDto);
    }
    updateStatusOfTrainingItems(statusDto:TrainingItemUpdateDto):Observable<any>{
      return this.httpClient.put(ApiConstants.CurriculumStatusUpdate_Api,statusDto);
    }

    updateCoreOrElectiveOfTrainingItems(coreOrElectiveDto:TrainingItemUpdateDto):Observable<any>{
      return this.httpClient.put(ApiConstants.CurriculumCoreOrElectiveUpdate_Api,coreOrElectiveDto);
    }

    getCurriculumAuthorization(): Observable<any>{
      return this.httpClient.get(ApiConstants.CurriculumAuthorization_Api);
    }

    getEQMSScopeForCurriculumManagement(): Observable<EQMSScopeHierarchy> {
      let observable: Observable<EQMSScopeHierarchy>;
      if (Object.keys(this.treeData).length > 0) {
        observable = of(this.treeData);
      }
      else {
        observable = this.httpClient.get<EQMSScopeHierarchy>(ApiConstants.EQMSScopesForCurriculumManagement_Api)
          .pipe(
            tap(treeData => this.treeData = treeData)
          );
      }
      return observable;
    }

    getCurriculumScopesForUser(curriculumScopeId : string) : Observable<any>{
      return this.httpClient.get(ApiConstants.CurriculmScopeCheckWithUsersScope_Api.replace('{curriculumScopeId}',curriculumScopeId))
    }

    getTrainingItemGroupsForCurriculum(curriculumId : string) : Observable<NameCode[]>{
      return this.httpClient.get<NameCode[]>(ApiConstants.TrainingItemGroupsForCurriculum_Api.replace('{curriculumScopeId}',curriculumId.toString()))
    }

    unAssignTrainingItemGroupsFromCurriculum (curriculumId : string, trainingItemGroupIds : string[]): Observable<any>{
      return this.httpClient.put(ApiConstants.UnAssignTrainingItemGroupsForCurriculum_Api.replace('{curriculumScopeId}',curriculumId.toString()),trainingItemGroupIds);
    }

  }
